// extracted by mini-css-extract-plugin
module.exports = {"container":"ResponseExample-module--container--G44Oz","header":"ResponseExample-module--header--3Z23o","title":"ResponseExample-module--title--3gXix"};